import { Document } from '@contentful/rich-text-types';
import { useRouter } from 'next/router';

// todo: refactor lpV2 footer
import Footer, { IFooterProps } from 'components/landing-pages-v2/shared/footer/Footer';
import FooterV2 from 'components/landing-pages-v2/shared/footerV2/Footer';

import { ISiteFooter } from 'declarations/contentful';

interface SharedContentfulFooterProps {
  footer?: ISiteFooter | null;
  extraLegalText?: Document;
  showCustomerTestimonialLegal?: boolean;
  showEligibilityLegal?: boolean;
  showPromotionLegal?: boolean;
  showThePdpCopyrightLegal?: boolean;
}

const DEFAULT_APPLE_STORE_LINK =
  'https://apps.apple.com/us/app/opendoor-buy-sell-homes/id1144498656';
const DEFAULT_GOOGLE_PLAY_LINK =
  'https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en_US';
const DEFAULT_HELP_CENTER_LINK = 'https://help.opendoor.com';
const FOOTER_V2_QUERY_PARAM = 'footer_v2';

const isFooterV2Enabled = (value: string | string[] | undefined) => {
  if (!value) {
    return false;
  }
  const values = Array.isArray(value) ? value : [value];
  return values.some((entry) => entry === '1' || entry === 'true' || entry === 'v2');
};

const SharedContentfulFooter = ({
  footer,
  extraLegalText,
  showCustomerTestimonialLegal,
  showEligibilityLegal,
  showPromotionLegal,
  showThePdpCopyrightLegal,
}: SharedContentfulFooterProps) => {
  const router = useRouter();
  const useFooterV2 = router.isReady && isFooterV2Enabled(router.query[FOOTER_V2_QUERY_PARAM]);
  const FooterComponent = useFooterV2 ? FooterV2 : Footer;

  if (footer) {
    return (
      <FooterComponent
        footerImage={footer.fields.footerImage?.fields.file.url}
        footerTitle={footer.fields.footerTitle}
        footerImageTitle={footer.fields.footerImage?.fields.title}
        footerNav={footer.fields.footerNav}
        sellInYourMarket={footer.fields.sellInYourMarket as IFooterProps['sellInYourMarket']}
        googlePlaystoreLink={footer.fields.googlePlaystoreLink || DEFAULT_GOOGLE_PLAY_LINK}
        appleStoreLink={footer.fields.appleStoreLink || DEFAULT_APPLE_STORE_LINK}
        helpCenterLink={footer.fields.helpCenterLink || DEFAULT_HELP_CENTER_LINK}
        backgroundColor={footer.fields.backgroundColor}
        extraLegalText={extraLegalText}
        showCustomerTestimonialLegal={showCustomerTestimonialLegal}
        showEligibilityLegal={showEligibilityLegal}
        showPromotionLegal={showPromotionLegal}
        showThePdpCopyrightLegal={showThePdpCopyrightLegal}
        locale={footer.sys.locale}
      />
    );
  }

  return (
    <FooterComponent
      googlePlaystoreLink={DEFAULT_GOOGLE_PLAY_LINK}
      appleStoreLink={DEFAULT_APPLE_STORE_LINK}
      helpCenterLink={DEFAULT_HELP_CENTER_LINK}
      backgroundColor="Grey"
    />
  );
};

export default SharedContentfulFooter;
